import {
    ModalDialog,
    ModalDialogBody,
    ModalDialogCloseButton,
    ModalDialogContent,
    ModalDialogNav,
} from '@vp/swan';
import BusinessNameDetail from './BusinessNameDetail';
import type { BusinessName } from '../../pages/BusinessNameGeneratorPage/components/BusinessNameResults/BusinessNameResults';

interface BusinessNameModalProps {
    businessName: BusinessName;
    onDismiss: () => void;
    trackingEventDetails: {
        category: string;
    };
    keyword?: string;
    industryKeywords?: string[];
}

const BusinessNameModal = ({
    businessName,
    onDismiss,
    trackingEventDetails,
    keyword,
    industryKeywords,
}: BusinessNameModalProps) => {
    return (
        <ModalDialog
            variant="panel-right"
            isOpen={!!businessName}
            onRequestDismiss={() => onDismiss()}
            bodyWidth="standard"
        >
            <ModalDialogContent aria-labelledby="modal dialog panel">
                <ModalDialogNav>
                    <ModalDialogCloseButton accessibleText="Close" />
                </ModalDialogNav>
                <ModalDialogBody marginBottom={0}>
                    <BusinessNameDetail
                        businessName={businessName}
                        trackingEventDetails={trackingEventDetails}
                        keyword={keyword}
                        industryKeywords={industryKeywords}
                    />
                </ModalDialogBody>
            </ModalDialogContent>
        </ModalDialog>
    );
};

export default BusinessNameModal;
